import axios from 'axios';
import Cookies from 'js-cookie';
import { isPublicAuthRoute } from './authRoutes';

// Configure axios base URL and credentials
axios.defaults.baseURL = process.env.VUE_APP_API_URL || 'http://localhost:3000';
axios.defaults.withCredentials = true;

// Update axios interceptor to handle both cookie and header authentication
axios.interceptors.request.use(config => {
  // Login/cadastro nao podem levar token: um jwt velho no cookie faz o Strapi
  // rejeitar a propria tentativa de entrar ou se registrar com 401.
  if (isPublicAuthRoute(config.url)) {
    delete config.headers.Authorization;
    return config;
  }

  const jwt = Cookies.get('jwt');
  if (jwt) {
    config.headers.Authorization = `Bearer ${jwt}`;
  }
  return config;
});

export const tryAutoLogin = async () => {
  try {
    const jwt = Cookies.get('jwt');
    if (!jwt) return null;
    
    const response = await axios.get('/api/users/me', {
      headers: {
        Authorization: `Bearer ${jwt}`
      }
    });
    
    return response.data;
  } catch (error) {
    console.error('Auto login error:', error);
    Cookies.remove('jwt');
    return null;
  }
};

export const login = async (credentials) => {
  // Descarta credencial morta antes de autenticar de novo.
  Cookies.remove('jwt');
  const response = await axios.post('/api/auth/local', {
    identifier: credentials.email,
    password: credentials.password
  });
  return response.data;
};

export const register = async (userData) => {
  Cookies.remove('jwt');
  const response = await axios.post('/api/auth/local/register', userData);
  return response.data;
};

// Process Google tokens directly
export const processGoogleTokens = async (idToken, accessToken) => {
  try {
    const response = await axios.post('/api/auth/google/callback', {
      id_token: idToken,
      access_token: accessToken
    });
    
    if (response.data?.jwt) {
      Cookies.set('jwt', response.data.jwt);
      axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.jwt}`;
    }
    
    return response.data;
  } catch (error) {
    console.error('Error processing Google tokens:', error);
    throw error;
  }
};

// Exchange OAuth code for token
export const exchangeAuthCode = async (code, provider = 'google') => {
  try {
    const response = await axios.post(`/api/auth/${provider}/exchange-code`, { code });
    
    if (response.data?.jwt) {
      Cookies.set('jwt', response.data.jwt);
      axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.jwt}`;
    }
    
    return response.data;
  } catch (error) {
    console.error('Error exchanging auth code:', error);
    throw error;
  }
};

// Handle social registration
export const handleSocialRegistration = async (userData) => {
  try {
    const response = await axios.post('/api/player/create-after-auth', userData, {
      headers: {
        Authorization: `Bearer ${Cookies.get('jwt')}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error creating player profile:', error);
    throw error;
  }
};
